import { SET_CURRENT_AREA } from 'actiontypes/map';
import Area from 'mapping/Area';
import { IArea } from 'types/map';

export type SetCurrentArea = {
  type: typeof SET_CURRENT_AREA,
  payload: { area: IArea },
};

export default function setCurrentArea(areaInfo: any): SetCurrentArea {
  const area = new Area({ ...areaInfo, ...(areaInfo.jsonInfo ?? {}) });
  return { type: SET_CURRENT_AREA, payload: { area } };
}